import React from "react"
import { Preloader } from "../../Preloader/preloader"
import { queryAccountsChangePass } from "../../../accounts2"
import { IAccount } from "../../../accounts2";
import "../Popup.css"
import { $SiteColors } from "../../../config/company-atts";

interface IPassChangePopup {
  openChangePassPopup: boolean,
  setOpenChangePassPopup: React.Dispatch<React.SetStateAction<boolean>>,
  chosenAcc: IAccount
}

export const PassChangePopup: React.FC<IPassChangePopup> = ({
  openChangePassPopup,
  setOpenChangePassPopup,
  chosenAcc,
}) => {
  const [values, setValues] = React.useState({
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  })
  const [errors, setErrors] = React.useState({
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  })
  const [isValid, setIsValid] = React.useState(false)
  const [showLoader, setShowLoader] = React.useState(false)
  const [disableInputs, setDisabledInputs] = React.useState(false)
  const [status, setStatus] = React.useState("")

  const overlay = React.useRef<HTMLDivElement>(null);
  const form = React.useRef<HTMLFormElement>(null);

  React.useEffect(() => {
    window.addEventListener("keyup", handleEscClose, false)
    //document.addEventListener("click", overlayClickClose, false)
    return () => {
      window.removeEventListener("keyup", handleEscClose, false)
      //document.removeEventListener("click", overlayClickClose, false)
    }
  }, [disableInputs])

  React.useEffect(() => {
    if (form.current) setIsValid(form.current.checkValidity())
  }, [values])

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const target = event.target
    const name = target.name
    const value = target.value
    setValues({ ...values, [name]: value })
    if (!event.target.validity.valid) {
      setErrors({ ...errors, [name]: target.title })
    } else setErrors({ ...errors, [name]: "" })
    if (name === "newPassword" && value !== values.newPasswordConfirm) {
      if (!event.target.validity.valid) {
        setErrors({
          ...errors,
          newPasswordConfirm: "Введенные пароли не совпадают",
          newPassword: target.title,
        })
      } else {
        setErrors({
          ...errors,
          newPasswordConfirm: "Введенные пароли не совпадают",
          newPassword: "",
        })
      }
    }
    if (name === "newPassword" && value === values.newPasswordConfirm) {
      setErrors({
        ...errors,
        newPasswordConfirm: "",
        newPassword: "",
      })
    }
  }

  function resetForm(
    newValues = { oldPassword: "", newPassword: "", newPasswordConfirm: "" },
    newErrors = { oldPassword: "", newPassword: "", newPasswordConfirm: "" },
    newIsValid = false,
  ) {
    setValues(newValues)
    setErrors(newErrors)
    setIsValid(newIsValid)
    setStatus("")
  }

  function handleCloseChangePopup() {
    if (!disableInputs) {
      setOpenChangePassPopup(false)
      resetForm()
    }
  }

  function handleEscClose(event: KeyboardEvent) {
    if (event.key === "Escape") {
      handleCloseChangePopup()
    }
  }

  /*function overlayClickClose(event: Event) {
    if (overlay.current && overlay.current === event.target) {
      handleCloseChangePopup()
    }
  }*/

  function handleChangePassword(event: React.FormEvent) {
    event.preventDefault()
    setStatus("success")
    setShowLoader(true)
    setIsValid(false)
    setDisabledInputs(true)
    queryAccountsChangePass(chosenAcc, values.oldPassword, values.newPassword)
      .then(res => {
        if (res.success) {
          setShowLoader(false)
          setIsValid(true)
          setDisabledInputs(false)
          setStatus("success")
        } else throw new Error()
      })
      .catch(() => {
        setShowLoader(false)
        setIsValid(true)
        setDisabledInputs(false)
        setStatus("failed")
      })
  }

  return (
    <div
      className={openChangePassPopup ? "popup popup_opened" : "popup"}
      ref={overlay}
    >
      <div className="popup__container">
        <h3 className="popup__title">Смена пароля</h3>
        <button
          className="popup__close"
          type="button"
          onClick={handleCloseChangePopup}
        >
          +
        </button>
        <form
          className="popup__form"
          ref={form}
          onSubmit={handleChangePassword}
        >
          <input
            type="password"
            className="popup__input"
            placeholder="Введите текущий пароль"
            name="oldPassword"
            value={values.oldPassword}
            required
            title="Обязательное для заполнения поле"
            onChange={handleChange}
            disabled={disableInputs}
          ></input>
          <span className="popup__input-error">{errors.oldPassword}</span>
          <input
            type="password"
            className="popup__input"
            placeholder="Введите новый пароль"
            name="newPassword"
            value={values.newPassword}
            title="Пароль должен содержать минимум 6 символов"
            required
            minLength={6}
            onChange={handleChange}
            disabled={disableInputs}
          ></input>
          <span className="popup__input-error">{errors.newPassword}</span>
          <input
            type="password"
            className="popup__input"
            placeholder="Подтвердите новый пароль"
            name="newPasswordConfirm"
            value={values.newPasswordConfirm}
            title="Введенные пароли не совпадают"
            required
            onChange={handleChange}
            pattern={values.newPassword}
            disabled={disableInputs}
          ></input>
          <span className="popup__input-error">
            {errors.newPasswordConfirm}
          </span>
          {status && (
            <p
              className={
                status === "success"
                  ? "popup__status"
                  : "popup__status popup__status_error"
              }
            >
              {status === "success"
                ? "Пароль успешно изменен!"
                : "Что-то пошло не так"}
            </p>
          )}
          <button type="submit" className="popup__button" disabled={!isValid}style={{backgroundColor:$SiteColors.getState().backBtnSubmit}}>
            {showLoader ? <Preloader small /> : "Сохранить"}
          </button>
        </form>
      </div>
    </div>
  )
}
